export default function callAPIMiddleware() {
    return next => action => {
        const { promise, types, ...rest } = action;
        if (!promise) {
            return next(action);
        }

        const [REQUEST, SUCCESS, FAILURE] = types;
        next({ ...rest, type: REQUEST });

        return promise
            .then(result => {
                return result.data;
            })
            .then(
                result => {
                    if (result.hasOwnProperty('error')) {
                        next({ ...rest, result, type: FAILURE });
                    } else {
                        next({ ...rest, result, type: SUCCESS });
                    }
                },
                error => {
                    next({ ...rest, error, type: FAILURE });
                }
            );
    };
}

export function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}
